import React from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

type ErrorBoundaryProps = {
  children: React.ReactNode
  onError?: (error: Error, info: React.ErrorInfo) => void
}

type ErrorBoundaryState = {
  hasError: boolean
}

export function ErrorBoundaryFallback() {
  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 flex items-center justify-center px-6">
      <div className="w-full max-w-md rounded-lg border border-red-900/50 bg-gray-900 p-6 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="rounded-md bg-red-950/70 p-2 text-red-300">
            <AlertTriangle className="h-5 w-5" />
          </div>
          <div className="min-w-0 space-y-2">
            <h1 className="text-base font-semibold text-gray-100">Algo salio mal</h1>
            <p className="text-sm leading-6 text-gray-400">
              La aplicacion encontro un error inesperado. Recarga la pagina para volver a intentarlo.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-md bg-red-600 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2 focus:ring-offset-gray-900"
        >
          <RefreshCw className="h-4 w-4" />
          Recargar
        </button>
      </div>
    </div>
  )
}

export class AppErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(_error: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.props.onError?.(error, info)
  }

  render() {
    if (this.state.hasError) return <ErrorBoundaryFallback />
    return this.props.children
  }
}
